import React from 'react'
import { InternalAppDashboardWidgetType as type } from '@/enums/InternalAppDashboardWidgetType'
import {
  NotificationsWidget,
  ReportSubmissionsWidget,
  TasksWidget,
  MessagesWidget
} from '@/components/dashboard/widgets'

const widgetComponents = []
widgetComponents[type.Notifications] = {
  outerProps: { className: 'col-md-6 col-lg-4 col-xl-3' },
  component: (item, props) => <NotificationsWidget widgetItem={item} {...props} />
}
widgetComponents[type.Messages] = {
  outerProps: { className: 'col-md-12 col-lg-12 col-xl-12' },
  component: (item, props) => <MessagesWidget widgetItem={item} {...props} />
}
widgetComponents[type.Tasks] = {
  outerProps: { className: 'col-md-6 col-lg-4 col-xl-4' },
  component: (item, props) => <TasksWidget widgetItem={item} {...props} />
}
widgetComponents[type.SubmittedReportGroups] = {
  outerProps: { className: 'col-md-12 col-lg-12 col-xl-5' },
  component: (item, props) => <ReportSubmissionsWidget widgetItem={item} {...props} />
}

export default widgetComponents



// WEBPACK FOOTER //
// ./src/internal-app/widgets.js